function ArrowLeft(props) {
  return (
    <svg width={20} height={20} fill="#4079F5" {...props}>
      <path d="M16.667 9.166H6.525l4.658-4.658L10 3.333 3.333 10 10 16.666l1.175-1.175-4.65-4.658h10.142V9.166z" />
    </svg>
  )
}

export default ArrowLeft
